var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5625 19.0311H3L1 25.0311H25L22.8125 19.0311H21.25",
    stroke: "#87A3CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12504 8.1561C4.47504 13.5061 9.85421 18.7186 12.625 20.6561C17.4251 17.4561 19.9167 12.8644 20.5625 10.9686C21.7625 5.0686 18.9375 2.1561 15.4375 1.3436C7.5625 -0.156387 5.29169 5.6561 5.12504 8.1561Z",
    stroke: "#87A3CC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0938,
    cy: 8.49988,
    r: 3.21875,
    stroke: "#87A3CC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.71875,
    cy: 20.6249,
    r: 0.34375,
    fill: "#87A3CC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6562,
    cy: 22.9999,
    r: 0.34375,
    fill: "#87A3CC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0312,
    cy: 21.9999,
    r: 0.34375,
    fill: "#87A3CC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9688,
    cy: 20.9374,
    r: 0.34375,
    fill: "#87A3CC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7812,
    cy: 22.9999,
    r: 0.34375,
    fill: "#87A3CC"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.90625,
    cy: 21.9999,
    r: 0.34375,
    fill: "#87A3CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/locationicon.c8e967a9d7d190474e97b6c333da9ada.svg";
export { ForwardRef as ReactComponent };